import { MotionA, MotionButton, MotionDiv, MotionH1, MotionH2, MotionP, MotionSection } from "./util";

export const Motion = {
  div: MotionDiv,
  a: MotionA,
  p: MotionP,
  h1: MotionH1,
  h2: MotionH2,
  button: MotionButton,
  section: MotionSection,
};
